export default __webpack_public_path__ + "static/media/icons.d770bf84.svg";